module.exports = __webpack_public_path__ + "static/media/twitter-bold.cc9109bb.svg";